/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Tags from '@base/Tags/Tags';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import { useSelector } from 'react-redux';
import H2 from '@base/H2/H2';
import H4 from '@base/H4/H4';
import H5 from '@base/H5/H5';
import Image from '@base/Image';
import Divider from '@base/Divider/Divider';
import textHelper from '@utils/textHelper';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { CHECKOUT_STARTED } from '@constants/segment';
import { segment } from '@actions/analytics';
import useCheckoutStartedEvtProps from '@hooks/useCheckoutStartedEvtProps';
import { evtNameCategoryMap } from '@constants/index';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import useIconicSubscriptionInfo from '@api/hooks/goal/useIconicSubscriptionInfo';
import { getExternalAppsAvailable } from '@selectors/topologies';
import { emptyList } from '@constants/empty';
import TriangleUp from '../TriangleUp';
import MobileIconicSection from './MobileIconicSection';

const unacademyLogo = 'iconic_subs/un.png';
const codeChefLogo = 'CodeChef.png';
const codeChefPlusBulletImage = 'iconic_subs/codechefplusBullet.png';
const codeChefPlusBullet2Image = 'iconic_subs/codechefplusBullet2.png';
const neetPGIconicBulletImage = 'iconic_subs/neetpgIconicBullet.png';
const neetPGIconicBullet2Image = 'iconic_subs/neetpgIconicBullet2.png';
const prepLadderIcon = 'iconic_subs/prepladderIcon.png';

const ResponsiveMobileIconicSection = styled(MobileIconicSection)`
  display: none;
  ${mediaQuery.uptoMobile} {
    display: block;
  }
`;

const SecWrapper = styled.section`
  width: 100%;
  position: relative;
  margin-bottom: ${Spacings.SPACING_30B};
  display: block;
  ${mediaQuery.uptoTablet} {
    margin-bottom: 56px;
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const Container = styled.div`
  background-color: var(--color-i-white);
  box-shadow: ${boxShadowGenerator()};
  border-radius: 8px;
  top: -40px;
  position: relative;
  margin: 0 auto;
  text-align: center;
  width: 1136px;
  padding-top: 40px;
  ${mediaQuery.uptoTablet} {
    width: 728px;
    padding-top: 32px;
  }
  ${mediaQuery.uptoMobile} {
    top: 0;
  }
`;

const Heading = styled(H2)`
  margin: ${Spacings.SPACING_4B} auto;
  max-width: 420px;
  ${mediaQuery.uptoTablet} {
    margin: 8px auto 4px;
  }
`;

const SubHeading = styled(H5)`
  font-weight: ${Fonts.REGULAR};
`;

const RowContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: 96px;
  margin-right: 96px;
  margin-top: 56px;
  ${mediaQuery.uptoTablet} {
    margin: 40px 61px 16px 61px;
  }
`;

const LeftContentContainer = styled.div`
  text-align: right;
  width: 400px;
  padding: 30px 0;
  max-width: 320px;
  ${mediaQuery.uptoTablet} {
    width: 238px;
    max-width: 238px;
    padding: 16px 0;
  }
`;

const MiddleContentContainer = styled.div`
  text-align: center;
  padding: 0 70px;
  position: relative;
  ${mediaQuery.uptoTablet} {
    padding: 0 46px;
  }
`;

const RightContentContainer = styled(LeftContentContainer)`
  text-align: left;
`;

const ImageWrapper = styled.div`
  user-drag: none;
  user-select: none;
  width: 72px;
  height: 56px;

  img {
    height: 56px;

    ${mediaQuery.uptoTablet} {
      width: 72px;
    }
  }
`;

const RoundIcon = styled.div`
  position: absolute;
  top: 33px;
  left: 59px;
  width: 24px;
  height: 24px;
  ${mediaQuery.uptoTablet} {
    left: 35px;
    top: 28px;
  }
`;

const PlusIcon = styled(RoundIcon)`
  top: 8px;
  left: 52px;
  width: 36px;
  height: 40px;
  ${mediaQuery.uptoTablet} {
    top: 8px;
    left: 28px;
  }
`;

const VerticalDivider = styled(Divider)`
  width: 2px;
`;

const LeftHeaderWrapper = styled(LeftContentContainer)`
  padding: 0;
`;

const RightHeaderWrapper = styled(RightContentContainer)`
  padding: 0;
`;

const RightHeaderContainer = styled.div`
  display: flex;
`;

const LeftHeaderContainer = styled(RightHeaderContainer)`
  justify-content: flex-end;
`;

const LeftHeader = styled(H4)`
  width: 207px;
  margin-right: 32px;
  ${mediaQuery.uptoTablet} {
    font-size: 18px;
    line-height: 150%;
    margin-right: 24px;
    margin-bottom: 28px;
  }
`;

const RightHeader = styled(LeftHeader)`
  margin-left: 32px;
  ${mediaQuery.uptoTablet} {
    margin-left: 24px;
  }
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoTablet} {
    font-size: 14px;
  }
`;

const EndText = styled(Description)`
  font-size: ${Fonts.P1};
  margin: 14px 0 80px 0;
  ${mediaQuery.uptoTablet} {
    margin: 0 auto 32px;
  }
`;

const ExamPricing = styled.span`
  color: var(--color-i-blue);
  padding-left: 5px;
  font-weight: bold;
  font-size: 24px;
  line-height: 120%;
`;

const ExamText = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 120%;
  color: var(--color-i-black);
  ${mediaQuery.uptoTablet} {
    font-size: 18px;
    display: inline-block;
  }
`;

const PrciningVal = styled.div`
  width: 600px;
  text-align: left;
  ${mediaQuery.uptoTablet} {
    width: auto;
  }
`;

const Pricing = styled.div`
  padding: 64px 96px;
  display: flex;
  justify-content: space-between;
  ${mediaQuery.uptoTablet} {
    padding: 27px 61px;
  }
`;

const LinkContainer = styled.div`
  align-self: center;
`;

const UNDivider = styled(Divider)`
  margin: 0 96px;
  ${mediaQuery.uptoTablet} {
    margin: 0 61px;
    height: 2px;
  }
`;

const NewLine = styled.br`
  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

const PrepLadderIconicSection = ({
  block,
  goalUID,
  goalDetails,
  goalSlug,
  countryCode,
  dataAnalytics,
  blockPosition
}) => {
  const eventProps = useCheckoutStartedEvtProps(goalDetails);
  const { extraBlockInfo } = block;

  let { iconicSubscriptionInfo } = useIconicSubscriptionInfo(
    `iconic-${goalUID}`
  );

  if (goalUID === 'LEARNCP') {
    iconicSubscriptionInfo = {
      benefits: [
        {
          id: 1,
          benefitHeader: 'Learn from experts',
          benefitDesc:
            'Whether you are newbie or a seasoned developer, learn coding from the expert computer scientists',
          sortOrder: 1,
          benefitLogo: null
        },
        {
          id: 2,
          benefitHeader: 'Practice Problems',
          benefitDesc:
            'Get access to the best set of problems in the domain - solve and discuss what you have learned',
          sortOrder: 2,
          benefitLogo: null
        },
        {
          id: 3,
          benefitHeader: 'Structured courses',
          benefitDesc:
            'Our courses are structured to understand everything from theoretical knowledge to practical applications',
          sortOrder: 3,
          benefitLogo: null
        },
        {
          id: 4,
          benefitHeader: 'Online Contests',
          benefitDesc:
            'Prepare yourself for the multiple programming challenges that take place through-out the month on CodeChef',
          sortOrder: 4,
          benefitLogo: null
        }
      ]
    };
  }

  const goalCurrencyCode = textHelper.currencySymbolMap(countryCode);
  const handleAnalytics = () => {
    segment.track(CHECKOUT_STARTED, eventProps, evtNameCategoryMap.BOTH);
  };

  const ContentInfo =
    iconicSubscriptionInfo &&
    iconicSubscriptionInfo.benefits.map((infoData, index) => {
      const isEven = index % 2 === 0;
      const InfoContainer = isEven
        ? LeftContentContainer
        : RightContentContainer;
      return (
        <>
          <InfoContainer>
            <H4>{infoData.benefitHeader}</H4>
            <Description>{infoData.benefitDesc}</Description>
          </InfoContainer>
          {isEven && (
            <MiddleContentContainer>
              <VerticalDivider orientation="vertical" />
              <RoundIcon>
                <Image
                  src={
                    goalUID === 'LEARNCP'
                      ? codeChefPlusBulletImage
                      : neetPGIconicBulletImage
                  }
                  alt={
                    goalUID === 'LEARNCP' ? 'CodeChef Bullet' : 'NEET PG Bullet'
                  }
                  width={24}
                  height={24}
                />
              </RoundIcon>
            </MiddleContentContainer>
          )}
        </>
      );
    });

  const externalApps =
    useSelector((state) => getExternalAppsAvailable(state, goalUID)) ||
    emptyList;
  const externalAppName = externalApps[0]
    ? externalApps[0].display_name || externalApps[0].displayName
    : '';
  const heading =
    goalUID === 'LEARNCP'
      ? 'Get a complete Hands-on learning experience'
      : 'ICONIC subscription';
  const subHeading = `Access to two of the best learning platforms, Unacademy & ${externalAppName}`;
  return (
    <>
      <ResponsiveMobileIconicSection
        type="Iconic"
        info={{
          heading,
          subHeading,
          logo: 'goal/un-prep.png',
          data: iconicSubscriptionInfo?.benefits
        }}
      />
      <SecWrapper>
        {blockPosition === 1 && <TriangleUp />}
        <Container>
          {goalUID !== 'LEARNCP' && (
            <Tags type="filled" bgColor="var(--color-i-orange-1)">
              Introducing
            </Tags>
          )}
          <Heading>{heading}</Heading>
          <SubHeading>{subHeading}</SubHeading>
          <RowContainer>
            <LeftHeaderWrapper>
              <LeftHeaderContainer>
                <LeftHeader>Get the best of Unacademy</LeftHeader>
                <ImageWrapper>
                  <Image
                    src={unacademyLogo}
                    alt="Unacademy"
                    height={56}
                    width={56}
                  />
                </ImageWrapper>
              </LeftHeaderContainer>
            </LeftHeaderWrapper>
            <MiddleContentContainer>
              <PlusIcon>
                <Image
                  src={
                    goalUID === 'LEARNCP'
                      ? codeChefPlusBullet2Image
                      : neetPGIconicBullet2Image
                  }
                  alt={
                    goalUID === 'LEARNCP' ? 'CodeChef Bullet' : 'NEET PG Bullet'
                  }
                  width={36}
                  height={36}
                />
              </PlusIcon>
            </MiddleContentContainer>
            <RightHeaderWrapper>
              <RightHeaderContainer>
                <ImageWrapper>
                  {goalUID === 'LEARNCP' ? (
                    <Image
                      src={codeChefLogo}
                      alt="CodeChef"
                      width={72}
                      height={72}
                    />
                  ) : (
                    <Image
                      src={prepLadderIcon}
                      alt="PrepLadder"
                      width={56}
                      height={72}
                    />
                  )}
                </ImageWrapper>
                <RightHeader>{`The best of ${externalAppName}`}</RightHeader>
              </RightHeaderContainer>
            </RightHeaderWrapper>
            {ContentInfo}
          </RowContainer>
          <EndText>and a lot more</EndText>
          <UNDivider />
          <Pricing>
            <PrciningVal>
              <ExamText>
                {`${extraBlockInfo?.goal_name || extraBlockInfo?.goalName} - ${
                  goalUID === 'LEARNCP' ? '' : 'ICONIC'
                } subscription starts`}
                <br /> from <NewLine />
                <ExamPricing>
                  {`${goalCurrencyCode}${textHelper.commas(
                    Math.round(
                      extraBlockInfo?.lowest_price ||
                        extraBlockInfo?.lowestPrice
                    )
                  )}`}
                  /month
                </ExamPricing>
              </ExamText>
            </PrciningVal>
            <LinkContainer>
              <UnderlineLink
                color="var(--color-i-green)"
                href="/goal/[goalSlug]/[goalUID]/subscribe"
                as={`/goal/${goalSlug}/${goalUID}/subscribe`}
                onClick={handleAnalytics}
              >
                <H4
                  color="var(--color-i-green)"
                  data-analytics={`${dataAnalytics}-viewPricing`}
                >
                  View pricing
                </H4>
              </UnderlineLink>
            </LinkContainer>
          </Pricing>
        </Container>
      </SecWrapper>
    </>
  );
};

PrepLadderIconicSection.propTypes = {
  block: PropTypes.objectOf(PropTypes.any).isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  goalDetails: PropTypes.objectOf(PropTypes.any),
  dataAnalytics: PropTypes.string
};

PrepLadderIconicSection.defaultProps = {
  dataAnalytics: '',
  goalDetails: {}
};

export default PrepLadderIconicSection;
